"use client";

import dynamic from "next/dynamic";
import { useEffect, useState } from "react";

const SupportLauncher = dynamic(
  () => import("./support-launcher").then((module) => module.SupportLauncher),
  { ssr: false },
);

/** Defer the support controls until their existing ten-second reveal point. */
export function SupportLauncherLoader() {
  const [ready, setReady] = useState(false);

  useEffect(() => {
    const timer = window.setTimeout(() => setReady(true), 10_000);
    return () => window.clearTimeout(timer);
  }, []);

  return ready ? <SupportLauncher /> : null;
}
